import { AbstractControl, ValidationErrors } from '@angular/forms';

export const json = (control: AbstractControl): ValidationErrors | null => {
  const key = 'json';

  const value: string = control.value;
  if (!value) return null;

  try {
    const result = JSON.parse(value);
    if (!result) throw 'empty object';
    if (typeof result !== 'object') throw 'not an object';
  } catch (error) {
    return { [key]: true };
  }

  return null;
};
